<ziro-loading-block [hidden]="isDisplayForm"></ziro-loading-block>
<div [hidden]="!isDisplayForm && !isDialPlanAccessForbidden" class="container-fluid">
  <ziro-collapsible-section-card [isSwitchHidden]="true" [isCollapsible]="false">
    <div class="row g-3">
      @if (
        isDialPlanGroupNotFoundForExistingLine &&
        !entity?.extension &&
        voicePolicies().sharedCallRoutingPolicy.policyName === 'Global'
      ) {
        <div
          [innerHtml]="
            'tkey;extension_selector.dial_plan_group_not_found.message'
              | escapeHtml
                : {
                    extension:
                      (teamsLine()?.lineUri | telephoneNumberFilter) +
                      (teamsLine()?.lineUriExtension ? ' ext. ' + teamsLine().lineUriExtension : ''),
                  }
          "
          class="alert alert-warning col-12"
        ></div>
      }
      @if (isDialPlanGroupNotFoundForExistingLine && voicePolicies().sharedCallRoutingPolicy.policyName !== 'Global') {
        <div
          [innerHtml]="
            'tkey;microsoft_360.view.teams.extensionSelection.shared_calling.error.no_dpg'
              | escapeHtml: { policyName: voicePolicies().sharedCallRoutingPolicy.policyName }
          "
          class="alert alert-warning col-12"
          data-automation="shared-calling-no-dial-plan-found-alert"
        ></div>
      }
      @if (microsoftDialPlanGroups().length === 0) {
        <div
          [innerHtml]="'tkey;microsoft_360.view.teams.nodialplans.configured.alert' | escapeHtml"
          class="alert alert-warning col-12"
        ></div>
      }

      <div class="col-12">
        <ziro-text [fieldId]="'dialPlanGroupId'"></ziro-text>
        <div
          class="ms-teams-dial-plan-toolbar d-flex flex-wrap align-items-end gap-3 gap-lg-4"
          [class.ms-teams-dial-plan-toolbar--with-filters]="
            selectedDialPlanGroup &&
            selectedDialPlanGroup?.callingType !== CallingType.SHARED_CALLING &&
            !licenseIncompatibleAlert
          "
        >
          <div
            class="ms-teams-dial-plan-toolbar__dpg flex-grow-1"
            [ngClass]="{ 'has-feedback ziro-forms-error': isSubmitted && !selectedDialPlanGroup }"
          >
            <label class="form-label mb-2 d-block">
              <span class="text-danger">*</span>
              {{ 'tkey;microsoft_360.view.teams.extensionSelection.dialplan.group' | translate }}
            </label>
            <ng-select
              id="dialPlanNameSelect"
              [labelForId]="'dialPlanNameSelect'"
              data-automation="ms-teams-calling-dial-plan-select"
              [items]="microsoftDialPlanGroups()"
              bindLabel="name"
              [(ngModel)]="selectedDialPlanGroup"
              [clearable]="false"
              (ngModelChange)="onDialPlanGroupChange()"
            ></ng-select>
          </div>
          <div
            class="ms-teams-dial-plan-toolbar__filters d-flex flex-wrap align-items-center gap-3 gap-md-4"
            [hidden]="
              !selectedDialPlanGroup ||
              selectedDialPlanGroup?.callingType === CallingType.SHARED_CALLING ||
              licenseIncompatibleAlert
            "
          >
            <div class="form-check ms-teams-dial-plan-toolbar__filter mb-0">
              <input
                type="checkbox"
                class="form-check-input"
                id="ms-extension-show-unavailable"
                data-automation="ms-unavailable-input"
                [(ngModel)]="showUnavailable"
                (ngModelChange)="applyComponentConfig()"
                [disabled]="isSubmitting"
              />
              <label
                class="form-check-label"
                [attr.data-automation]="'ms-unavailable-input-label'"
                for="ms-extension-show-unavailable"
              >
                <i class="{{ ziroIcons.UNAVAILABLE }} text-danger"></i>
                {{ 'tkey;microsoft_360.view.teams.extensionSelection.show_unavailable.label' | translate }}
              </label>
            </div>
            <div class="form-check ms-teams-dial-plan-toolbar__filter mb-0">
              <input
                type="checkbox"
                class="form-check-input"
                id="ms-extension-show-recently-deleted"
                data-automation="ms-extension-show-recently-deleted-input"
                [(ngModel)]="showRecentlyDeleted"
                (ngModelChange)="applyComponentConfig()"
                [disabled]="isSubmitting"
              />
              <label
                class="form-check-label"
                [attr.data-automation]="'ms-show-recently-deleted-input-label'"
                for="ms-extension-show-recently-deleted"
              >
                <i [ngClass]="ziroIcons.HISTORY"></i>
                {{ 'tkey;microsoft_360.view.teams.extensionSelection.show_revently_deleted.label' | translate }}
              </label>
            </div>
          </div>
        </div>
      </div>

      @if (selectedDialPlanGroup?.callingType === CallingType.EXTENSION) {
        <div class="col-12 main-number-section" data-automation="selected-group-main-number-alert">
          <div class="main-number-section__outside-label">
            {{ 'tkey;microsoft_360.view.teams.extensionSelection.main_number.outside_label' | translate }}
          </div>

          <div
            class="main-number-direct-line-card"
            [class.main-number-direct-line-card--selected]="isResourceAccount() && isMainNumberSelected"
            [class.main-number-direct-line-card--disabled]="isResourceAccount() && isMainNumberRadioDisabled()"
            data-automation="selected-group-main-number-direct-line-card"
            [ngbTooltip]="
              isResourceAccount() && isMainNumberAssignedToOtherUser()
                ? ('tkey;microsoft_360.view.teams.extensionSelection.main_number.assigned.tooltip'
                  | translate: { upn: mainNumberAssignedDescription() })
                : null
            "
            [disableTooltip]="!isResourceAccount() || !isMainNumberAssignedToOtherUser()"
            [container]="'body'"
            [placement]="'top'"
          >
            <div class="main-number-direct-line-card__row d-flex align-items-center gap-3">
              <div class="main-number-direct-line-card__body flex-grow-1 min-w-0">
                @if (isResourceAccount()) {
                  <label
                    class="main-number-direct-line-card__select d-flex gap-2 align-items-center mb-0 w-100"
                    for="ms-resource-account-main-number-only"
                    (click)="onMainNumberDirectLineClick($event)"
                  >
                    <input
                      type="radio"
                      class="form-check-input flex-shrink-0 main-number-direct-line-card__radio"
                      id="ms-resource-account-main-number-only"
                      data-automation="selected-group-main-number-radio"
                      name="ms-resource-account-extension-choice"
                      [attr.aria-label]="
                        'tkey;microsoft_360.view.teams.extensionSelection.main_number.resource_account.message'
                          | translate
                      "
                      [checked]="isMainNumberSelected"
                      [disabled]="isMainNumberRadioDisabled()"
                      (click)="$event.preventDefault()"
                      (keydown)="onMainNumberRadioKeydown($event)"
                    />
                    <span class="flex-grow-1 min-w-0">
                      <span
                        class="main-number-direct-line-card__number d-block"
                        data-automation="selected-group-main-number-alert-number"
                      >
                        {{ selectedDialPlanGroup?.mainNumber | telephoneNumberFilter }}
                      </span>
                      <span class="main-number-direct-line-card__message d-block">
                        @if (isMainNumberAssignedToOtherUser()) {
                          {{
                            'tkey;microsoft_360.view.teams.extensionSelection.main_number.assigned.message'
                              | translate: { upn: mainNumberAssignedDescription() }
                          }}
                        } @else {
                          {{ 'tkey;microsoft_360.view.teams.extensionSelection.main_number.message' | translate }}
                        }
                      </span>
                    </span>
                  </label>
                } @else {
                  <div class="main-number-direct-line-card__static">
                    <div
                      class="main-number-direct-line-card__number"
                      data-automation="selected-group-main-number-alert-number"
                    >
                      {{ selectedDialPlanGroup?.mainNumber | telephoneNumberFilter }}
                    </div>
                    <p class="main-number-direct-line-card__message mb-0">
                      {{ 'tkey;microsoft_360.view.teams.extensionSelection.main_number.message' | translate }}
                    </p>
                  </div>
                }
              </div>
              @if (isResourceAccount()) {
                <div
                  class="main-number-direct-line-card__badge flex-shrink-0"
                  data-automation="selected-group-main-number-state-badge"
                  aria-live="polite"
                >
                  @if (isMainNumberSelected) {
                    {{ 'tkey;microsoft_360.view.teams.extensionSelection.main_number.selected.badge' | translate }}
                  } @else if (isMainNumberAssignedToOtherUser()) {
                    {{ 'tkey;microsoft_360.view.teams.extensionSelection.main_number.assigned.badge' | translate }}
                  } @else {
                    {{ 'tkey;microsoft_360.view.teams.extensionSelection.main_number.direct_line.badge' | translate }}
                  }
                </div>
              }
            </div>
          </div>
        </div>
      }

      @if (selectedDialPlanGroup?.callingType === CallingType.SHARED_CALLING && isDisplaySharedCallingAlert) {
        <div class="col-12">
          <div
            data-automation="selected-group-shared-calling-alert"
            class="alert mt-0 shared-calling-div"
            [ngClass]="{
              'alert-info': dialPlanGroupSharedCallingPolicy,
              'alert-danger': !dialPlanGroupSharedCallingPolicy,
            }"
          >
            @if (selectedDialPlanGroup?.mainNumber) {
              <h4 data-automation="selected-group-shared-calling-alert-number" class="mb-3">
                <strong>
                  {{ 'tkey;microsoft_360.view.teams.extensionSelection.shared_calling.label' | translate }}
                  {{ selectedDialPlanGroup?.mainNumber | telephoneNumberFilter }}
                </strong>
              </h4>
            }
            @if (dialPlanGroupSharedCallingPolicy) {
              <p
                class="mb-0"
                [innerHTML]="
                  'tkey;microsoft_360.view.teams.extensionSelection.shared_calling.message'
                    | escapeHtml
                      : {
                          policyName: dialPlanGroupSharedCallingPolicy.policyName,
                          resourceAccountName: dialPlanGroupSharedCallingPolicy.resourceAccountDisplayName,
                        }
                "
              ></p>
            }
            @if (!dialPlanGroupSharedCallingPolicy) {
              <p
                class="mb-0"
                [innerHTML]="
                  'tkey;microsoft_360.view.teams.extensionSelection.shared_calling.error.no_number' | escapeHtml
                "
              ></p>
            }
          </div>
        </div>
      }
    </div>

    <ziro-loading-block
      [hidden]="!isSearching || isDialPlanGroupNotFoundForExistingLine"
      data-automation="microsoft-teams-dial-plan-inventory-loading"
    ></ziro-loading-block>

    @if (licenseIncompatibleAlert) {
      <div data-automation="teams-calling-incompatible-license-alert" class="alert alert-danger mt-3">
        {{ licenseIncompatibleAlert | translate }}
      </div>
    }

    <div
      [hidden]="
        isSearching ||
        !selectedDialPlanGroup ||
        selectedDialPlanGroup?.callingType === CallingType.SHARED_CALLING ||
        licenseIncompatibleAlert
      "
    >
      @if (isZpcSyncWarningPresent()) {
        <div class="row mt-2" data-automation="sync-warning-alert">
          <div class="col-12">
            <div class="alert alert-warning mb-0">
              <strong>{{ 'tkey;extension_selector.sync.warning.zpm' | translate }}</strong>
            </div>
          </div>
        </div>
      }
      <div class="row">
        <div class="col-12" data-automation="teams-calling-extension-selector">
          <ziro-extension-selector
            class="col-12 px-0"
            [fieldId]="'extension'"
            [isHosted]="true"
            [usageLocationProps]="{
              valid: !this.hasExtensionError,
              numberLocation: this.numberUsageLocation,
              upn: this.upn(),
              userLocation: this.userUsageLocation,
            }"
            [msLicenses]="this.ms360View().microsoft365UserLicenses"
            [tenantId]="tenantId()"
            (usageLocationUpdated)="_onUpdateUsageLocation($event)"
          ></ziro-extension-selector>
        </div>
      </div>
    </div>
    @if (!isDialPlanAccessForbidden || isDialPlanGroupNotFoundForExistingLine) {
      <div class="row">
        <ziro-teams-alternate-numbers
          [tenantId]="tenantId()"
          [userPrincipalName]="upn()"
          (alternateNumberDeleted)="refreshDialPlanInventories()"
        ></ziro-teams-alternate-numbers>
      </div>
    }

    <ziro-loading-block
      [hidden]="(showValue && !isNumberLocationValidationInProgress) || isDialPlanGroupNotFoundForExistingLine"
    ></ziro-loading-block>
    @if (
      !isSearching &&
      ((entity?.extension && selectedDialPlanGroup?.callingType !== CallingType.SHARED_CALLING) ||
        canSaveWithMainNumberOnly() ||
        dialPlanGroupSharedCallingPolicy) &&
      showValue &&
      !licenseIncompatibleAlert &&
      !isNumberLocationValidationInProgress &&
      !hasExtensionError
    ) {
      <ziro-microsoft-teams-calling-form
        [tenantId]="tenantId()"
        [teamsLine]="teamsLine()"
        [voicePolicies]="voicePolicies()"
        [upn]="upn()"
        [onPremUpn]="onPremUpn"
        [lineUri]="entity?.extension"
        [isMainNumberSelected]="isMainNumberSelected"
        [mainNumber]="selectedDialPlanGroup?.mainNumber"
        [phoneNumberAssignmentFieldConfig]="phoneNumberAssignmentFieldConfig"
        [voicePoliciesFieldConfig]="voicePoliciesFieldConfig"
        [bandwidthFieldConfig]="bandwidthEmergencyCallingFieldConfig"
        [bandwidthEntity]="bandwidthEntity"
        [initialBandwidthEndpointId]="initialBandwidthEndpointId"
        [isExtensionChanged]="isExtensionChanged"
        [dialPlanFieldConfig]="selectedDialPlanGroup"
        [isBandwidthConfiguredWithoutE911Dlr]="isBandwidthConfiguredWithoutE911Dlr"
        [isResourceAccount]="isResourceAccount()"
        [isZpcSyncWarningPresent]="isZpcSyncWarningPresent()"
        [isAdWriteDownConfigured]="isAdWriteDownConfigured"
        [isEntraWriteDownConfigured]="isEntraWriteDownConfigured"
        [initialZiroDraasSharedCallingExtension]="initialZiroDraasSharedCallingExtension"
        [initialLineUri]="initialLineUri"
        [initialLineUriExtension]="initialLineUriExtension"
        [initialDialPlanGroup]="initialDialPlanGroup"
        [sharedCallingPolicy]="dialPlanGroupSharedCallingPolicy"
        [isExistingSharedCalling]="isExistingSharedCalling"
        [initialExistingNumber]="initialExistingNumber"
      ></ziro-microsoft-teams-calling-form>
    }
  </ziro-collapsible-section-card>
</div>
